import { Scale } from "lucide-react";

// Golden ratio: 1.618 - Login card positioned at golden section point
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function Login() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden" data-testid="login-page">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/landing-bg.jpg')" }}
      />
      {/* Dark overlay for contrast */}
      <div className="absolute inset-0 bg-black/40" />

      {/* Content - Golden Ratio Layout (61.8% / 38.2%) */}
      <div className="relative z-10 min-h-screen flex">
        {/* Left spacer - 61.8% golden ratio */}
        <div className="hidden lg:block" style={{ flex: "0 0 61.8%" }} />

        {/* Right section - 38.2% login area */}
        <div className="flex-1 flex items-center justify-center px-6 lg:pr-[8%] lg:pl-0">
          <div className="w-full max-w-[360px]">

            {/* Login Card - Transparent with green border */}
            <div
              className="rounded-2xl p-8 backdrop-blur-xl"
              style={{
                background: "rgba(0, 0, 0, 0.35)",
                border: "1px solid rgba(91, 154, 139, 0.6)",
                boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(91, 154, 139, 0.15)"
              }}
              data-testid="login-card"
            >
              {/* Logo */}
              <div className="text-center mb-8">
                <div
                  className="w-14 h-14 rounded-2xl mx-auto mb-4 flex items-center justify-center"
                  style={{ background: "rgba(91, 154, 139, 0.9)", boxShadow: "0 4px 12px rgba(91, 154, 139, 0.4)" }}
                >
                  <Scale className="h-7 w-7 text-white" />
                </div>
                <h1 className="text-2xl font-bold text-white tracking-tight">LegalStory</h1>
                <p className="text-xs mt-1" style={{ color: "rgba(255,255,255,0.5)" }}>CRM Judicial</p>
              </div>

              {/* Divider */}
              <div className="h-px mb-6" style={{ background: "linear-gradient(to right, transparent, rgba(91, 154, 139, 0.4), transparent)" }} />

              {/* Google Login Button */}
              <button
                onClick={handleGoogleLogin}
                className="w-full h-12 rounded-xl text-sm font-medium flex items-center justify-center gap-3 transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
                style={{
                  background: "rgba(255, 255, 255, 0.95)",
                  color: "#333",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
                }}
                data-testid="google-login-btn"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>
                Iniciar sesión con Google
              </button>

              {/* Access note */}
              <p className="text-center text-[10px] mt-5" style={{ color: "rgba(255,255,255,0.35)" }}>
                Acceso restringido a usuarios autorizados
              </p>
            </div>

            {/* Credits - Below card */}
            <div className="text-center mt-6">
              <p className="text-[10px] font-medium tracking-wider" style={{ color: "rgba(255,255,255,0.4)" }}>
                DESIGNED BY
              </p>
              <p className="text-xs font-semibold mt-0.5" style={{ color: "rgba(91, 154, 139, 0.8)" }}>
                Allcom Tech
              </p>
              <p className="text-[10px] mt-0.5" style={{ color: "rgba(255,255,255,0.3)" }}>
                Mario Pino
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
